var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ZoomImage',{staticStyle:{"z-index":"102"},attrs:{"pose":_vm.pose}},[_c('markupFullscreen',{ref:"markupFullscreen",attrs:{"readonly":_vm.readonly,"detailPage":_vm.detailPage,"blueprint":_vm.blueprint},on:{"fullscreen":_vm.toggleZoom,"showMarkerDetails":_vm.showMarkerDetails}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd63233e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Markers/ZoomMarkup.vue
// module id = 485
// module chunks = 1